import React from 'react';
import { ShoppingCart, Book, Download, Globe } from 'lucide-react';

const BuyPage = () => {
  return (
    <div>
      <section className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Buy the Book</h1>
          <p className="text-xl opacity-90">Choose your format and start reading today</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* eBook */}
              <div className="bg-white rounded-xl shadow-lg p-8 text-center">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Download className="w-8 h-8 text-amber-600" />
                </div>
                <h3 className="text-2xl font-bold mb-4">eBook</h3>
                <div className="text-4xl font-bold text-amber-600 mb-6">$9.99</div>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span> Instant download
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span> PDF, EPUB, MOBI
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span> Read on any device
                  </li>
                </ul>
                <button className="w-full bg-amber-500 text-gray-900 py-3 rounded-lg font-semibold hover:bg-amber-400 transition">
                  Buy eBook
                </button>
              </div>

              {/* Paperback */}
              <div className="bg-white rounded-xl shadow-lg p-8 text-center border-2 border-amber-500 relative">
                <div className="absolute top-0 right-0 bg-amber-500 text-white px-4 py-1 rounded-bl-lg rounded-tr-lg font-semibold text-sm">
                  Most Popular
                </div>
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Book className="w-8 h-8 text-amber-600" />
                </div>
                <h3 className="text-2xl font-bold mb-4">Paperback</h3>
                <div className="text-4xl font-bold text-amber-600 mb-6">$14.99</div>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span> 384 pages
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span> Premium quality paper
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span> Free shipping
                  </li>
                </ul>
                <button className="w-full bg-amber-500 text-gray-900 py-3 rounded-lg font-semibold hover:bg-amber-400 transition">
                  Buy Paperback
                </button>
              </div>

              {/* Bundle */}
              <div className="bg-white rounded-xl shadow-lg p-8 text-center">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Globe className="w-8 h-8 text-amber-600" />
                </div>
                <h3 className="text-2xl font-bold mb-4">Complete Bundle</h3>
                <div className="text-4xl font-bold text-amber-600 mb-6">$19.99</div>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span> eBook + Paperback
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span> Exclusive bonus content
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-500 mr-2">✓</span> Author Q&A
                  </li>
                </ul>
                <button className="w-full bg-amber-500 text-gray-900 py-3 rounded-lg font-semibold hover:bg-amber-400 transition">
                  Buy Bundle
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BuyPage;